__turbopack_context__.v({
  "articles": "Articles-module__a0YMDW__articles",
  "inverted": "Articles-module__a0YMDW__inverted",
  "navbarExpanded": "Articles-module__a0YMDW__navbarExpanded",
});
